import { ReactElement } from 'react'

import { NextPage } from 'app/types/decalarations/next'

import HelpCenterLayout from '~/components/layouts/HelpCenterLayout'
import MainLayout from '~/components/layouts/MainLayout'
import HelpCenterSearchView from '~/views/HelpCenter/HelpCenterSearchView'

const HelpCenterSearchPage: NextPage = () => <HelpCenterSearchView />

HelpCenterSearchPage.getLayout = (page: ReactElement) => (
  <MainLayout>
    <HelpCenterLayout>{page}</HelpCenterLayout>
  </MainLayout>
)

HelpCenterSearchPage.getMeta = (intl) => ({
  title: intl.formatMessage({
    defaultMessage: 'Help Centre'
  }),
  description: intl.formatMessage({
    defaultMessage: 'Pit Stop for Assistance'
  })
})

export default HelpCenterSearchPage
